"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountRef = exports.QBOJournalEntryLineDetail = exports.QBOJournalEntryLine = exports.QBOJournalEntry = exports.toJournalEntry = exports.toQBOJournalEntry = exports.JournalEntryLine = exports.validateTotals = exports.updateTotals = exports.JournalEntry = exports.PostingTypes = void 0;
const Errors_1 = require("./Errors");
const DOMAIN = "QBO";
const CURRENCY = "USD";
const CURRENCY_NAME = "United States Dollar";
const JOURNAL_ENTRY_DETAIL_TYPE = "JournalEntryLineDetail";
exports.PostingTypes = {
    Credit: "Credit",
    Debit: "Debit",
};
class JournalEntry {
    constructor() {
        this.locationId = "";
        this.lines = [];
        this.totalCredits = 0;
        this.totalDebits = 0;
    }
}
exports.JournalEntry = JournalEntry;
function updateTotals(journalEntry) {
    journalEntry.totalCredits = 0;
    journalEntry.totalDebits = 0;
    journalEntry.lines.reduce((je, line) => {
        if (line.postingType === exports.PostingTypes.Credit) {
            je.totalCredits += line.amount;
        }
        else { //Assume Debit
            je.totalDebits += line.amount;
        }
        return je;
    }, journalEntry);
    // Round to two decimals
    journalEntry.totalCredits = Number(journalEntry.totalCredits.toFixed(2));
    journalEntry.totalDebits = Number(journalEntry.totalDebits.toFixed(2));
}
exports.updateTotals = updateTotals;
function validateTotals(je) {
    if (je.totalCredits !== je.totalDebits) {
        throw new Errors_1.ValidationError(`Unbalanced journal entry ${je.name} (${je.externalId})!`
            + ` totalCredits=${je.totalCredits} and totalDebits=${je.totalDebits}`);
    }
}
exports.validateTotals = validateTotals;
class JournalEntryLine {
    constructor() {
        this.amount = 0;
        this.postingType = exports.PostingTypes.Credit;
        this.accountExternalId = "";
    }
}
exports.JournalEntryLine = JournalEntryLine;
function toQBOJournalEntry(journalEntry) {
    const qboJournalEntry = new QBOJournalEntry();
    if (journalEntry.externalId) {
        qboJournalEntry.Id = journalEntry.externalId;
    }
    qboJournalEntry.DocNumber = journalEntry.name;
    qboJournalEntry.TxnDate = journalEntry.date;
    qboJournalEntry.PrivateNote = journalEntry.memo;
    qboJournalEntry.SyncToken = journalEntry.syncToken ?? "1";
    // Loop through each line
    journalEntry.lines.forEach((line) => {
        // Set QBOJournalEntryLine
        const qboJournalEntryLine = new QBOJournalEntryLine();
        if (line.externalId) {
            qboJournalEntryLine.setId(line.externalId);
        }
        qboJournalEntryLine.setAmount(line.amount);
        if (line.description) {
            qboJournalEntryLine.setDescription(line.description);
        }
        qboJournalEntryLine.setDetailType(JOURNAL_ENTRY_DETAIL_TYPE);
        const accountRef = new AccountRef(line.accountExternalId, line.accountExternalName);
        const qboJournalEntryLineDetail = new QBOJournalEntryLineDetail();
        qboJournalEntryLineDetail.setPostingType(line.postingType);
        qboJournalEntryLineDetail.setAccountRef(accountRef);
        qboJournalEntryLine.setJournalEntryLineDetail(qboJournalEntryLineDetail);
        qboJournalEntry.Line.push(qboJournalEntryLine);
    });
    return qboJournalEntry;
}
exports.toQBOJournalEntry = toQBOJournalEntry;
function toJournalEntry(locationId, input) {
    const journalEntry = new JournalEntry();
    journalEntry.locationId = locationId;
    journalEntry.externalId = input.Id;
    journalEntry.date = input.TxnDate;
    journalEntry.name = input.DocNumber;
    journalEntry.memo = input.PrivateNote;
    journalEntry.syncToken = input.SyncToken;
    journalEntry.lines = input.Line?.map((qboLine) => {
        const line = new JournalEntryLine();
        line.externalId = qboLine.Id ?? undefined;
        line.amount = qboLine.Amount;
        line.description = qboLine.Description;
        line.accountExternalId = qboLine.JournalEntryLineDetail?.AccountRef?.value ?? "";
        line.accountExternalName = qboLine.JournalEntryLineDetail?.AccountRef?.name;
        line.postingType = qboLine.JournalEntryLineDetail?.PostingType;
        return line;
    }) ?? [];
    // Ensure totals are set
    updateTotals(journalEntry);
    return journalEntry;
}
exports.toJournalEntry = toJournalEntry;
class QBOJournalEntry {
    constructor() {
        this.Adjustment = false;
        this.domain = DOMAIN;
        this.CurrencyRef = {
            value: CURRENCY,
            name: CURRENCY_NAME,
        };
        this.Line = [];
    }
    getLine() {
        return this.Line;
    }
    setLine(value) {
        this.Line = value;
    }
}
exports.QBOJournalEntry = QBOJournalEntry;
class QBOJournalEntryLine {
    constructor() {
        this.JournalEntryLineDetail = new QBOJournalEntryLineDetail();
        this.DetailType = JOURNAL_ENTRY_DETAIL_TYPE;
        this.Amount = 0;
        this.Description = "";
        this.Id = null;
    }
    getJournalEntryLineDetail() {
        return this.JournalEntryLineDetail;
    }
    setJournalEntryLineDetail(value) {
        this.JournalEntryLineDetail = value;
    }
    getDetailType() {
        return this.DetailType;
    }
    setDetailType(value) {
        this.DetailType = value;
    }
    getAmount() {
        return this.Amount;
    }
    setAmount(value) {
        this.Amount = value;
    }
    getDescription() {
        return this.Description;
    }
    setDescription(value) {
        this.Description = value;
    }
    getId() {
        return this.Id;
    }
    setId(value) {
        this.Id = value;
    }
}
exports.QBOJournalEntryLine = QBOJournalEntryLine;
class QBOJournalEntryLineDetail {
    constructor() {
        this.PostingType = "";
        this.AccountRef = null;
    }
    getPostingType() {
        return this.PostingType;
    }
    setPostingType(value) {
        this.PostingType = value;
    }
    getAccountRef() {
        return this.AccountRef;
    }
    setAccountRef(value) {
        this.AccountRef = value;
    }
}
exports.QBOJournalEntryLineDetail = QBOJournalEntryLineDetail;
class AccountRef {
    constructor(v, n) {
        this.value = v;
        this.name = n ?? "";
    }
    getName() {
        return this.name;
    }
    setName(val) {
        this.name = val;
    }
    getValue() {
        return this.value;
    }
    setValue(val) {
        this.value = val;
    }
}
exports.AccountRef = AccountRef;
//# sourceMappingURL=JournalEntry.js.map